import { useI18n } from '../../hooks/useI18nFormatters';

import { glyph } from '../../theme/glyph';

import { ContextMenuContent } from '../../components/common/context-menu/ContextMenuContent';
import { DeveloperMenu } from '../../components/common/context-menu/DeveloperMenu';

import { useScript } from './useScripts';

export function ScriptNavigationItemContextMenuContent(props) {
  const { i18n } = useI18n();
  // const ctx = useContextMenuContext();

  const { script } = useScript({ scriptId: props.scriptId });

  function onAction(key) {
    switch (key) {
      case 'start':
        props.onStartRequest();
        break;
      case 'rename':
        props.onRenameRequest();
        break;
      case 'delete':
        props.onDeleteRequest();
        break;
      default:
        break;
    }
  }

  return (
    <ContextMenuContent.List>
      <ContextMenuContent.ListItem
        label={i18n.messageFormatter('common.rename')}
        onPress={() => {
          onAction('rename');
        }}
      />

      <ContextMenuContent.ListItem
        label={i18n.messageFormatter('common.start')}
        icon={glyph.core.play}
        onPress={() => {
          onAction('start');
        }}
      />

      <DeveloperMenu onIdRequest={() => script?.id} onResourceRequest={() => script} />

      <ContextMenuContent.Divider />
      <ContextMenuContent.ListItem
        label={i18n.messageFormatter('common.delete')}
        variant="danger"
        icon={glyph.core.trashFill}
        onPress={() => {
          onAction('delete');
        }}
      />
    </ContextMenuContent.List>
  );
}
